import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import OrderDetailsModal from "../../../Components/Caisses/Orders/OrderDetailsModal";
import {
  DefaultClient,
  Panier,
  Reduction,
  addClient,
  addToPanier,
  confirmOrder,
  findDefaultClientsBySociete,
  resetPanier,
  resetReduction,
  setOperationType,
  // Make sure addToRefunded is exported from your Slice if you use it individually,
  // otherwise we pass the array to setOperationType
} from "../../../_App/Redux/Slices/Caisse/PanierSlice";
import { selectedTable } from "../../../_App/Redux/Slices/Caisse/CaisseSlice";
import { debounce } from "lodash"; // Add this import

import {
  ListOnlineOrders,
  ListOrders,
  findOrdersByOrganisation,
  getOrderByIdApi,
  order,
  resetCachedOrders,
  saveOrderApi,
  selectedOrder,
  updateOrderApi,
  resetSelectedOrder, // Ensure this is imported
} from "../../../_App/Redux/Slices/Orders/OrderSlice";
import {
  SelectedOrganisation,
  SelectedOrganisationId,
  selectJournalCaisse,
  selectUser,
  societe,
  societeId,
} from "../../../_App/Redux/Slices/Auth/authSlice";

import {
  UnpaidTicket,
  findTicketsByOrderApi,
  saveTicketApi,
} from "../../../_App/Redux/Slices/tickets/TicketSlice";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { DepotDefautOrganisation } from "../../../_App/Redux/Slices/depot/depotSlice";
import { findVendeurs } from "../../../_App/Redux/Slices/users/vendeurSlice";
import { parametrageCaisse } from "../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import {
  createClientsApi,
  findClientById,
  findClientByMobile,
  findClientBySocieteApi,
} from "../../../_App/Redux/Slices/client/clientSlice";

import ClientType from "../../../_App/Types/Entites/ClientType";

import { toast } from "react-toastify";
import { ToastSuccess } from "../../../Shared/Toasts/ToastSuccess";
import { ClientSchema } from "../../../_App/Schemas/ClientSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { Resolver, useForm } from "react-hook-form";
import {
  findSoucheCommande,
  findSoucheCommandeOnline,
  generateOrderNumber,
  ImpressionTicket,
} from "../../../_App/Helpers/helpers";
import { updateArticleStockApi } from "../../../_App/Redux/Slices/article/articleSlice";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import OnlineOrderInvoice from "../../../Components/Caisses/Orders/OnlineOrderInvoice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  findSocieteLivraison,
  SocieteLivraison,
} from "../../../_App/Redux/Slices/societe/societeSlice";
import { PrintAction } from "../../../Shared/Hardware/PrintAction";
import iconv from "iconv-lite";
import {
  saveBonReductionApi,
  updateBon,
} from "../../../_App/Redux/Slices/reduction/reductionSlice";
import BonReductionType from "../../../_App/Types/Entites/ReductionType";

interface PaymentRightBarProps {
  visible: boolean;
  setVisible: any;
  ArticlesToPay: any;
  miniOrder: any;
}

const OnlineOrderConfirmation: React.FC<PaymentRightBarProps> = ({
  visible,
  setVisible,
  miniOrder,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const cart = useSelector(Panier);
  const reduction = useAppSelector(Reduction);
  let tempReduction = reduction;
  const Organisation = useAppSelector(SelectedOrganisation);
  const Societe = useAppSelector(societe);

  const retrievedOrder = useAppSelector(order);
  const currentOrder = useAppSelector(selectedOrder);
  const openedOrder = retrievedOrder ? retrievedOrder : currentOrder;
  const selectedtable = useAppSelector(selectedTable);
  const orders = useAppSelector(ListOnlineOrders);
  const unpaidTicket = useAppSelector(UnpaidTicket);
  const journal = useAppSelector(selectJournalCaisse);
  const defaultClient = useAppSelector(DefaultClient);
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const user = useAppSelector(selectUser);

  const societe_id = useAppSelector(societeId);

  const [tempCash, setTempCash] = useState<number | 0>(0);
  const [tempCheque, setTempCheque] = useState<number | 0>(0);
  const [showModalTicket, setShowModalTicket] = useState(false);

  const [ticketId, setTicketId] = useState<string | null>(null);
  const currentDepot = useAppSelector(DepotDefautOrganisation);
  const parametrage = useAppSelector(parametrageCaisse);
  const btnClass = parametrage && parametrage.barcodeOnly ? " big-btn" : "";
  const { t } = useTranslation();
  const openedOrderId = openedOrder?._id;

  // --- NEW STATE FOR EXCHANGE LOGIC ---
  const [isExchangeMode, setIsExchangeMode] = useState(false);
  const [exchangeSelection, setExchangeSelection] = useState<
    Record<string, { selected: boolean; quantity: number; originalItem: any }>
  >({});

  const total = openedOrder
    ? miniOrder
      ? miniOrder.total
      : unpaidTicket
      ? unpaidTicket.total
      : openedOrder.total
    : cart.operationType === "Retour"
    ? cart.totalNet
    : cart.totalNet;

  const refund = async (type: string) => {
    if (type === "retour") {
      // ... (Existing Logic for Retour / Avoir) ...
      // [Keeping your existing code for type === 'retour' intact]
      if (retrievedOrder) {
        try {
          const { value: deliveryFee } = await Swal.fire({
            title:
              "Voulez-vous rembourser les frais de livraison à la société de livraison ?",
            input: "number",
            inputLabel: "frais de livraison",
            inputValue: delivery_companies[0]?.frais_livraison,
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non, passe",
            inputValidator: (value) => {
              const parsedValue = parseFloat(value);
              if (!value || isNaN(parsedValue) || parsedValue <= 0) {
                return "Please enter a valid amount!";
              }
            },
          });

          let parsedDeliveryFee = 0;
          if (deliveryFee !== null) {
            parsedDeliveryFee = parseFloat(deliveryFee);
          }

          retrievedOrder.items.forEach((value: any) => {
            dispatch(
              updateArticleStockApi({
                id: value.article._id,
                depotId: currentDepot._id,
                soldQuantity: -value.qteretour || -value.quantity,
                type: value?.type,
                defaut_id: value?.defaut_id,
              }),
            );
          });

          let avoir = { ...retrievedOrder };

          avoir.items = avoir.items.map((item: any) => ({
            ...item,
            quantity: item.quantity * -1,
            prix_total: item.prix_total * -1,
            prixNet: item.prixNet * -1,
          }));

          avoir.total = -avoir.total;
          avoir.totalNet = -avoir.totalNet;
          avoir.status = "Avoir";
          avoir.date = new Date();
          avoir.organisation_id = avoir.organisation_id._id;
          avoir.client_id = avoir.client_id._id;
          avoir.perteRetour = parsedDeliveryFee;

          delete avoir._id;
          delete avoir.typeRemise;
          delete avoir.retour_echanges;
          delete avoir.createdAt;

          const saveResponse = await dispatch(saveOrderApi(avoir));

          if (!saveResponse?.payload?.success) {
            throw new Error("Avoir saving failed");
          }

          const updateResponse = await dispatch(
            updateOrderApi({
              orderId: retrievedOrder._id,
              status: "Retour",
            }),
          );

          if (!updateResponse?.payload?.success) {
            throw new Error("Order update failed");
          }

          Swal.fire({
            icon: "success",
            title: "Succès",
            text: "Avoir créé et commande mise à jour avec succès !",
            timer: 2000,
            showConfirmButton: false,
          });
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Erreur",
          });
        }
        navigate("/commandes");
      }
    }
  };

  // --- NEW FUNCTION TO VALIDATE EXCHANGE ---
  const validateExchange = async () => {
    const itemsToRefund: any[] = [];

    // 1. Filter selected items
    Object.values(exchangeSelection).forEach((selection) => {
      if (selection.selected && selection.quantity > 0) {
        const item = selection.originalItem;

        // Prepare the refunded item object (Negative values)
        itemsToRefund.push({
          article: item.article,
          quantity: -selection.quantity, // Negative quantity for returns
          sold_quantity: -selection.quantity,
          prix_unitaire: item.prix_unitaire,
          prix_total: -(item.prix_unitaire * selection.quantity),
          paid_quantity: 0,
          type: "defaut",
          note: item.note || "",
          remise: item.remise || 0,
          remiseClient: 0,
          prixNet:
            -(
              item.prix_unitaire *
              selection.quantity *
              ((item.remise || 0) / 100)
            ) || -(item.prix_unitaire * selection.quantity), // Fallback calculation
        });
      }
    });

    if (itemsToRefund.length === 0) {
      ToastWarning("Veuillez sélectionner au moins un article à échanger.");
      return;
    }

    // 2. Add to Refunded / Cart logic
    // We send the list of refunded items to the setOperationType action
    // which handles populating the cart state for the exchange
    await dispatch(resetPanier(0)); // Clear existing cart first

    dispatch(setOperationType({ type: "Echange", refunded: itemsToRefund }));
    dispatch(resetSelectedOrder());

    // Add client info to cart context
    if (openedOrder?.client_id) {
      dispatch(addClient(openedOrder.client_id));
    }

    // 3. Navigate to Caisse
    navigate("/caisse");
  };

  // Helper to handle selection changes
  const handleSelectionChange = (
    itemId: string,
    field: "selected" | "quantity",
    value: any,
  ) => {
    setExchangeSelection((prev) => {
      const current = prev[itemId];
      // Validate max quantity
      let newVal = value;
      if (field === "quantity") {
        if (newVal > current.originalItem.quantity)
          newVal = current.originalItem.quantity;
        if (newVal < 1) newVal = 1;
      }

      return {
        ...prev,
        [itemId]: {
          ...current,
          [field]: newVal,
        },
      };
    });
  };

  const [currentClient, setCurrentClient] = useState<ClientType>();

  useEffect(() => {
    const getClient = async () => {
      if (cart.client_id) {
        const loyalClient = await dispatch(
          findClientById(cart.client_id.toString()),
        );
        if (loyalClient && loyalClient.payload)
          setCurrentClient(loyalClient.payload);
      }
      if (societe_id) {
        const ress = dispatch(findSocieteLivraison(societe_id));
      }
    };
    getClient();
  }, [cart.client_id]);

  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [note, setNote] = useState("");
  const [mobile, setMobile] = useState("");
  const resetCartToDefault = async () => {
    if (defaultClient) {
      dispatch(resetPanier(parametrage.timbreTicket || 0));
      dispatch(resetCachedOrders());
      dispatch(resetReduction());
      dispatch(addClient(defaultClient._id));
    }
  };

  const handleConfirmOrder = async (data: any, client: string) => {
    // ... (Your existing confirm order logic) ...
    let order = { ...data };
    delete order.calculatedQuantity;
    delete order.orderConfirmed;
    let response: any;
    if (currentOrganisation) {
      order.organisation_id = currentOrganisation;
    }
    order.items = cart.items;
    order.date = new Date();
    order.table_id = selectedtable ? selectedtable._id : null;
    order.total = cart.items.reduce(
      (acc: any, item: any) => acc + item.prix_total,
      0,
    );
    order.totalNet = cart.items.reduce(
      (acc: any, item: any) => acc + item.prixNet,
      0,
    );
    if (appliedBon) {
      order.totalNet =
        appliedBon.amount > order.totalNet
          ? 0
          : Math.max(0, order.totalNet - appliedBon.amount);
      order.bonReduction = appliedBon; // optional: trace which bon was used

      // Mark the bon as (partially) consumed
      dispatch(
        updateBon({
          id: appliedBon._id,
          data: {
            valide: false,
          },
        }),
      );
    }
    order.order_number = await findSoucheCommandeOnline(
      currentOrganisation,
      dispatch,
    );
    order.status = isPaid
      ? "Payée"
      : cart.items.some((item: any) => item.outOFStock === true)
      ? "Pre-confirmée"
      : "Nouvelle";
    order.client_id = client;
    order.clientRemise = cart.clientRemise;
    order.societe_id = societe_id;
    order.depots_id = currentDepot._id;
    order.type = "online";

    if (journal) order.journal_id = journal?._id;
    if (user) order.vendeur = user?._id;
    if (user) order.user_id = user?._id;
    try {
      const response = await dispatch(saveOrderApi(order));

      if (response.payload.success) {
        setSavedOrder(response.payload.data._id);
        const obj = {
          ticket: {
            main_order: response.payload.data._id,
            ticket_order: response.payload.data,
            type: "Total",
            process: "Online",
          },
        };
        const responseTicket = await dispatch(saveTicketApi(obj));

        if (responseTicket.payload.success)
          setTicketId(responseTicket.payload.data?.ticket?._id);
        const dataTicket = {
          ticket: obj.ticket,
          paymentList: [],
        };
        await callImpression(dataTicket, "Ticket Caisse");
      }
      order.items.forEach((value: any) => {
        dispatch(
          updateArticleStockApi({
            id: value.article._id,
            depotId: currentDepot._id,
            soldQuantity: value.quantity,
            type: value?.type,
            defaut_id: value?.defaut_id,
          }),
        );
      });
      console.log("response", response);
      if (response.payload.success) {
        dispatch(confirmOrder());
        resetCartToDefault();
        setNom("");
        setAddress("");
        setMobile("");
        setEmail("");
        setNote("");
        navigate("/commandes");
      } else {
        ToastWarning(response.payload.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };
  const debouncedFetchClient = useRef(
    debounce((mobileNumber: string) => {
      fetchClientByMobile(mobileNumber);
    }, 500), // 500ms delay
  ).current;

  // Handle mobile input change
  const handleMobileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setMobile(value);

    // Trigger debounced API call
    if (value && value.length >= 6) {
      debouncedFetchClient(value);
    }
  };

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      debouncedFetchClient.cancel();
    };
  }, [debouncedFetchClient]);
  const [savedOrder, setSavedOrder] = useState(undefined);
  const delivery_companies = useAppSelector(SocieteLivraison);
  const [isLoadingClient, setIsLoadingClient] = useState(false); // Add loading state
  const [refundCount, setRefundCount] = useState(0); // Add this
  const [foundClient, setFoundClient] = useState<any>(null); // Add this to store the found client
  const [isClientBlocked, setIsClientBlocked] = useState(false); // Add this
  const [availableBons, setAvailableBons] = useState<any[]>([]); // valid contre-bons for the client
  const [appliedBon, setAppliedBon] = useState<any | null>(null); // the one the user confirmed to use
  const fetchClientByMobile = async (mobileNumber: string) => {
    if (!mobileNumber || mobileNumber.length < 6) {
      return;
    }

    setIsLoadingClient(true);
    try {
      const clientResponse = await dispatch(findClientByMobile(mobileNumber));
      const client = clientResponse.payload?.[0];

      if (client) {
        // Store the full client object
        // Store valid contre-bons returned by the backend
        const bons = (client.contreBonsValide || []).filter(
          (b: any) => getBonRemaining(b) > 0,
        );
        setAvailableBons(bons);
        setAppliedBon(null); // reset any previously applied bon for the new client

        if (bons.length > 0) {
          ToastWarning(
            `💳 Ce client a ${bons.length} bon(s) de réduction valide(s)`,
          );
        }
        setFoundClient(client);
        setIsClientBlocked(client.blocked || false);

        // Populate form with client data
        setNom(client.nom || "");
        setPrenom(client.prenom || "");
        setEmail(client.email || "");
        setAddress(client.address || "");
        setNote(client.note || "");
        setRefundCount(client.refundCount || 0);

        if (client._id) {
          dispatch(addClient(client._id));
        }

        // Show warning if client has refunds
        if (client.refundCount > 0) {
          ToastWarning(`⚠️ Client sensible - ${client.refundCount} retour(s)`);
        } else if (!client.blocked) {
          ToastSuccess("Client déja enregistré !");
        }

        // Show warning if client is blocked
        if (client.blocked) {
          ToastWarning("⚠️ Client bloqué !");
        }
      } else {
        // No client found, reset
        setAvailableBons([]);
        setAppliedBon(null);

        setFoundClient(null);
        setIsClientBlocked(false);
        setRefundCount(0);
      }
    } catch (error) {
      console.error("Error fetching client:", error);
      setFoundClient(null);
      setIsClientBlocked(false);
    } finally {
      setIsLoadingClient(false);
    }
  };

  const getTwoYearsLater = (from: Date = new Date()): Date => {
    const date = new Date(from);
    date.setFullYear(date.getFullYear() + 2);
    return date;
  };
  // Remaining usable value of a bon
  const getBonRemaining = (bon: any): number =>
    Math.max(0, (Number(bon?.amount) || 0) - (Number(bon?.consumed) || 0));

  // Ask the user to confirm using a contre-bon as a reduction
  const applyContreBon = async () => {
    const usableBons = availableBons.filter((b) => getBonRemaining(b) > 0);
    if (usableBons.length === 0) {
      ToastWarning("Aucun bon de réduction utilisable.");
      return;
    }

    // If several bons, let the user choose; otherwise take the only one
    let chosen = usableBons[0];
    if (usableBons.length > 1) {
      const { value: bonId } = await Swal.fire({
        title: "Choisir un bon de réduction",
        input: "select",
        inputOptions: usableBons.reduce(
          (opts: Record<string, string>, b: any) => {
            opts[b._id] = `${b.code || "Bon"} — ${getBonRemaining(b).toFixed(
              3,
            )}`;
            return opts;
          },
          {},
        ),
        inputPlaceholder: "Sélectionner un bon",
        showCancelButton: true,
        confirmButtonText: "Continuer",
        cancelButtonText: "Annuler",
      });
      if (!bonId) return; // user cancelled
      chosen = usableBons.find((b) => b._id === bonId);
    }

    const remaining = getBonRemaining(chosen);
    const orderTotal = Number(total) || 0;
    // Never deduct more than the order is worth
    const usedAmount = Math.min(remaining, orderTotal);

    const confirm = await Swal.fire({
      title: "Utiliser ce bon de réduction ?",
      html: `Bon <b>${chosen.code || ""}</b><br/>
           Solde du bon: <b>${remaining.toFixed(3)}</b><br/>
           Réduction appliquée: <b>${usedAmount.toFixed(3)}</b>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Oui, appliquer",
      cancelButtonText: "Non",
    });

    if (confirm.isConfirmed) {
      setAppliedBon({ ...chosen, usedAmount });
      ToastSuccess(`Bon appliqué: -${usedAmount.toFixed(3)}`);
    }
  };

  const removeContreBon = () => {
    setAppliedBon(null);
    ToastWarning("Bon de réduction retiré.");
  };
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // First verify the client's mobile number if provided
    if (mobile) {
      try {
        const clientResponse = await dispatch(findClientByMobile(mobile));
        const client = clientResponse.payload[0];

        if (foundClient && foundClient.blocked) {
          Swal.fire({
            title: "Client bloqué",
            text: "Ce client est bloqué et ne peut pas passer de commande.",
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }
      } catch (error) {
        console.error("Error checking client status:", error);
      }
    }

    Swal.fire({
      title: "Voulez-vous confirmer ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ... (Keep existing confirm logic) ...
        console.log("cart", cart);
        if (cart.operationType === "Echange" && cart.refundedOrder) {
          console.log("cart", cart.refundedOrder);

          Swal.fire({
            title: "Voulez-vous retourner les articles en stock ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
          }).then(async (returnResult) => {
            let order: any = { ...cart };
            delete order.calculatedQuantity;
            delete order.orderConfirmed;

            if (currentOrganisation) {
              order.organisation_id = currentOrganisation;
            }

            order.items = [...cart.items, ...cart.refundedItems];
            order.date = new Date();
            order.table_id = selectedtable ? selectedtable._id : null;

            // --- LOGIC CHANGE START ---
            // Check if the original order was paid.
            // Replace 'Payée' with your actual status string (e.g., 'Paid' or 'Completed')

            order.total = cart.total < 0 ? 0 : cart.total.toFixed(3);
            order.totalNet = cart.totalNet < 0 ? 0 : cart.totalNet.toFixed(3);

            order.type = "online";
            order.status = "Nouvelle";
            order.client_id = cart.client_id;
            order.clientRemise = cart.clientRemise;
            order.societe_id = societe_id;
            order.depots_id = currentDepot._id;
            order.user_id = user?._id;

            const deliveryResult = await Swal.fire({
              title: "Facturer les frais de livraison pour cet échange ?",
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Oui",
              cancelButtonText: "Non",
            });

            order.deliveryFees = deliveryResult.isConfirmed;
            // Exchange difference from the product lines only:
            // new products - returned products (returned lines have a negative prixNet)
            const differenceEchange = Number(
              [...cart.items, ...cart.refundedItems]
                .reduce(
                  (sum: number, item: any) => sum + (Number(item.prixNet) || 0),
                  0,
                )
                .toFixed(3),
            );
            order.differenceEchange = differenceEchange;

            // New products cheaper than the returned ones: save the difference
            // as a bon de réduction for the client and keep it on the order for the facture
            if (differenceEchange < 0) {
              const twoyearslater = getTwoYearsLater();

              let data: BonReductionType = {
                date: new Date(),
                amount: Math.abs(differenceEchange),
                dateEcheance: twoyearslater,
                depot_id: currentDepot._id,
                code: "",
                type: "Bon de réduction",
                consumed: 0,
                sous_bon: false,
                valide: true,
                client_id: cart.client_id,
              };
              const bonRes = await dispatch(saveBonReductionApi(data));
              const savedBon = bonRes.payload?.data;
              if (savedBon?._id) {
                order.bonEchange = {
                  _id: savedBon._id,
                  code: savedBon.code,
                  amount: savedBon.amount,
                  dateEcheance: savedBon.dateEcheance,
                };
              } else {
                ToastWarning(
                  "Le bon de réduction n'a pas pu être enregistré.",
                );
              }
            }
            const avoir = await dispatch(saveOrderApi(order));

            if (avoir.payload.success) {
              // Link the bon to the exchange order so the facture can find it
              if (order.bonEchange?._id && avoir.payload.data?._id) {
                dispatch(
                  updateBon({
                    id: order.bonEchange._id,
                    data: { order_id: avoir.payload.data._id },
                  }),
                );
              }
              const returnedArticlesToStock = returnResult.isConfirmed;

              if (returnedArticlesToStock) {
                cart.refundedItems.forEach((value: any) => {
                  dispatch(
                    updateArticleStockApi({
                      id: value.article._id,
                      depotId: currentDepot._id,
                      soldQuantity: value.quantity,
                      type: value?.type,
                      organisation: currentOrganisation,
                      defaut_id: value?.defaut_id,
                    }),
                  );
                });
              }
              cart.items.forEach((value: any) => {
                dispatch(
                  updateArticleStockApi({
                    id: value.article._id,
                    depotId: currentDepot._id,
                    soldQuantity: value.quantity,
                    type: value?.type,
                    organisation: currentOrganisation,
                    defaut_id: value?.defaut_id,
                  }),
                );
              });

              const obj = {
                ticket: {
                  main_order: cart.refundedOrder._id,
                  ticket_order: avoir.payload.data,
                  type: "Total",
                  process: cart.operationType,
                  returnedArticlesToStock: returnedArticlesToStock,
                },
                order: avoir.payload.data,
                payment: [],
                Mvt: [],
              };

              await dispatch(saveTicketApi(obj));
              await dispatch(resetCartToDefault);
            }
          });
        } else if (openedOrder) {
          // ... (Keep existing logic) ...
          let newStatus = "";
          if (openedOrder.status === "Pre-confirmée") {
            newStatus = "Nouvelle";
          } else if (
            openedOrder.status === "En cours" ||
            openedOrder.status === "Nouvelle"
          ) {
            newStatus = "En livraison";
          }

          if (newStatus) {
            if (newStatus === "En livraison") {
              const { value: deliveryCompanyId } = await Swal.fire({
                title: "Sélectionnez la société de livraison",
                input: "select",
                inputOptions: delivery_companies.reduce(
                  (options: any, company: any) => {
                    options[company._id] = company.libelle;
                    return options;
                  },
                  {} as Record<string, string>,
                ),
                inputPlaceholder: "Choisir une société",
                showCancelButton: true,
                inputValidator: (value) => {
                  if (!value) {
                    return "Veuillez sélectionner une société de livraison";
                  }
                },
              });
              if (deliveryCompanyId) {
                const selectedCompany = delivery_companies.find(
                  (c: any) => c._id === deliveryCompanyId,
                );

                // Free delivery: fees are not charged and won't appear on the invoice
                const deliveryFees = !freeDelivery;
                const societeLivraison = deliveryFees
                  ? selectedCompany
                  : { ...selectedCompany, frais_livraison: 0 };

                // Now confirm the status change
                Swal.fire({
                  title: "Voulez-vous confirmer le changement de statut ?",
                  text: `Société de livraison: ${selectedCompany?.libelle} - ${
                    deliveryFees
                      ? "frais de livraison inclus"
                      : "livraison gratuite"
                  }`,
                  icon: "question",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Oui",
                  cancelButtonText: "Non",
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    const response = await dispatch(
                      updateOrderApi({
                        orderId: openedOrder._id,
                        status: "En livraison",
                        paidProducts: [],
                        vendeur: null,
                        societe_livraison: societeLivraison,
                        deliveryFees,
                      }),
                    );
                    if (response.payload.success) {
                      Swal.fire("success", `Commande ${newStatus}.`, "success");
                      navigate("/commandes");
                    }
                  }
                });
              }
            } else {
              const response = await dispatch(
                updateOrderApi({
                  orderId: openedOrder._id,
                  status: newStatus,
                  paidProducts: [],
                  vendeur: openedOrder.vendeur,
                }),
              );

              if (response.payload.success) {
                Swal.fire("success", `Commande ${newStatus}.`, "success");
                navigate("/commandes");
              }
            }
          } else if (openedOrder.status === "En livraison") {
            dispatch(setOperationType({ type: "Pay", refunded: [] }));
          }
        } else {
          // Create client ONLY if not found
          if ((nom && mobile) || cart.client_id) {
            let clientId = foundClient?._id; // Use existing client if found

            // Only create new client if no client was found
            if (!clientId) {
              const clientData = {
                nom,
                prenom,
                email,
                mobile,
                address,
                note,
              };

              try {
                const newClient = await dispatch(createClientsApi(clientData));
                if (newClient?.payload?.success) {
                  clientId = newClient?.payload?.data._id;
                } else {
                  throw new Error("Failed to create client");
                }
              } catch (error) {
                console.error("Error creating client:", error);
                Swal.fire("Error", "Failed to create client.", "error");
                return;
              }
            }

            // Proceed with order using clientId
            if (clientId) {
              await handleConfirmOrder(cart, clientId);
              navigate("/commandes");
            }
          } else {
            Swal.fire("Error", "Please fill all the required fields.", "error");
          }
        }
      }
    });
  };

  const paymentRightBarRef = useRef<HTMLDivElement>(null);

  // ... (Keep existing useEffects) ...
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        paymentRightBarRef.current &&
        !paymentRightBarRef.current.contains(event.target as Node)
      ) {
        if (setVisible) setVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setVisible]);

  useEffect(() => {
    if (societe_id) {
      dispatch(findClientBySocieteApi(societe_id));
      dispatch(findDefaultClientsBySociete(societe_id));
    }
    if (openedOrder && openedOrder._id)
      dispatch(findTicketsByOrderApi(openedOrder._id));

    if (currentOrganisation) dispatch(findVendeurs(currentOrganisation));
  }, [dispatch, openedOrder]);

  const [showTicket, setShowTicket] = useState(false);
  const [showFacture, setShowFacture] = useState(false);

  const handleCloseModal = () => {
    setShowFacture(false);
  };

  const [isPaid, setIsPaid] = useState(false);
  const [freeDelivery, setFreeDelivery] = useState(false);

  const handleToggle = () => {
    setIsPaid(!isPaid);
  };

  // ... (Keep callImpression) ...
  const callImpression = async (dataTicket: any, type: any) => {
    const lines: any = ImpressionTicket(
      type,
      {
        ...dataTicket,
        societe: Societe,
        organisation: Organisation,
        user,
        vendeur: user,
      },
      parametrage,
    );

    const finalBuffer = (() => {
      const allBytes: number[] = [];
      lines.forEach((line: any) => {
        if (line instanceof Uint8Array) {
          allBytes.push(...line);
        } else {
          const buf = iconv.encode(line + "\n", "ISO-8859-1");
          allBytes.push(...buf);
        }
      });
      return new Uint8Array(allBytes);
    })();

    await PrintAction(finalBuffer, parametrage.OpenTiroire);
  };

  return (
    <div
      className={
        setVisible
          ? visible === true
            ? "col-right-content-container payment-rightbar displayed"
            : "col-right-content-container payment-rightbar"
          : "fixed-payment-rightbar"
      }
      style={{ width: "610px" }}
      ref={paymentRightBarRef}
    >
      {/* ... (Keep existing Modals) ... */}
      {ticketId ? (
        <OrderDetailsModal
          show={showTicket}
          setShow={setShowTicket}
          ticket_id={ticketId}
          order_id={openedOrderId}
        />
      ) : null}
      {cart.refundedOrder && (
        <OnlineOrderInvoice
          order_id={cart.refundedOrder._id}
          show={showFacture}
          setShow={setShowFacture}
          onClose={handleCloseModal}
          type={cart.operationType}
        />
      )}

      <div className="widget-message" style={{ padding: "10px" }}>
        <div className="widget-title mb-10">
          <h5>Confirmation</h5>
        </div>
      </div>

      <div className="activity-section">
        <div className="widget-todo">
          <div className="todo-content">
            <div className="todo-title">
              <h6>
                <span className="align-self-center">
                  {isExchangeMode
                    ? t("Sélectionner articles à échanger")
                    : t("Informations client")}
                </span>
              </h6>
            </div>
          </div>
        </div>

        <div>
          <div className="navbar-item flex-row search-ul navbar-dropdown">
            <div className="nav-item align-self-center search-animated">
              {/* --- CONDITIONAL RENDERING: EXCHANGE LIST vs CLIENT FORM --- */}
              {isExchangeMode ? (
                <div
                  className="mt-2"
                  style={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    padding: "0 10px",
                  }}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Article</th>
                        <th style={{ width: "80px" }}>Qté</th>
                      </tr>
                    </thead>
                    <tbody>
                      {retrievedOrder &&
                        retrievedOrder.items.map((item: any) => {
                          const itemId = item._id || item.article._id;
                          const selection = exchangeSelection[itemId];
                          if (!selection) return null;

                          return (
                            <tr key={itemId}>
                              <td>
                                <div className="n-chk">
                                  <label className="new-control new-checkbox checkbox-primary">
                                    <input
                                      type="checkbox"
                                      className="new-control-input"
                                      checked={selection.selected}
                                      onChange={(e) =>
                                        handleSelectionChange(
                                          itemId,
                                          "selected",
                                          e.target.checked,
                                        )
                                      }
                                    />
                                    <span className="new-control-indicator"></span>
                                  </label>
                                </div>
                              </td>
                              <td style={{ whiteSpace: "normal" }}>
                                {item.article.libelle} <br />
                                <small className="text-muted">
                                  (Acheté: {item.quantity})
                                </small>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={selection.quantity}
                                  max={item.quantity}
                                  min={1}
                                  disabled={!selection.selected}
                                  onChange={(e) =>
                                    handleSelectionChange(
                                      itemId,
                                      "quantity",
                                      parseInt(e.target.value),
                                    )
                                  }
                                  style={{ padding: "5px", height: "30px" }}
                                />
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-between mt-4">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setIsExchangeMode(false)}
                      style={{ width: "45%" }}
                    >
                      {t("Annuler")}
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={validateExchange}
                      style={{ width: "45%", background: "#009688" }}
                    >
                      {t("Valider")}
                    </button>
                  </div>
                </div>
              ) : (
                // --- ORIGINAL CLIENT FORM ---
                <form onSubmit={onSubmit}>
                  <input
                    type="text"
                    className="form-control search-form-control"
                    placeholder="Nom"
                    value={
                      cart && cart.refundedOrder
                        ? cart.refundedOrder.client_id.nom
                        : retrievedOrder?.client_id?.nom
                        ? retrievedOrder?.client_id?.nom
                        : cart.client_id && cart.client_id.nom
                        ? cart.client_id.nom
                        : nom
                    }
                    onChange={(e) => setNom(e.target.value)}
                  />

                  <input
                    type="email"
                    className="form-control search-form-control"
                    placeholder="Email"
                    value={
                      cart && cart.refundedOrder
                        ? cart.refundedOrder.client_id.email
                        : retrievedOrder?.client_id?.email
                        ? retrievedOrder?.client_id?.email
                        : cart.client_id && cart.client_id.email
                        ? cart.client_id.email
                        : email
                    }
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  <div style={{ position: "relative" }}>
                    <input
                      type="tel"
                      className="form-control search-form-control"
                      placeholder="Téléphone"
                      value={
                        cart && cart.refundedOrder
                          ? cart.refundedOrder.client_id.mobile
                          : retrievedOrder?.client_id?.mobile
                          ? retrievedOrder?.client_id?.mobile
                          : cart.client_id && cart.client_id.mobile
                          ? cart.client_id.mobile
                          : mobile
                      }
                      onChange={handleMobileChange}
                    />
                    {isLoadingClient && (
                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <div
                          className="spinner-border spinner-border-sm text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* After the mobile input field */}
                  {refundCount > 0 && (
                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      ⚠️ Attention: Ce client a effectué {refundCount} retour(s)
                    </div>
                  )}
                  {availableBons.length > 0 && !appliedBon && (
                    <div style={{ marginBottom: "10px" }}>
                      <div
                        style={{
                          color: "#009688",
                          fontSize: "12px",
                          marginBottom: "5px",
                        }}
                      >
                        💳 {availableBons.length} bon(s) de réduction
                        disponible(s)
                      </div>
                      <button
                        type="button"
                        className="btn btn-outline-success btn-sm"
                        onClick={applyContreBon}
                      >
                        Utiliser un bon de réduction
                      </button>
                    </div>
                  )}

                  {appliedBon && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#e8f5e9",
                        borderRadius: "6px",
                        padding: "8px 10px",
                        marginBottom: "10px",
                        fontSize: "13px",
                      }}
                    >
                      <span>
                        Bon <b>{appliedBon.code || ""}</b> appliqué : −
                        {Number(appliedBon.usedAmount).toFixed(3)}
                      </span>
                      <button
                        type="button"
                        className="btn btn-link btn-sm text-danger p-0"
                        onClick={removeContreBon}
                      >
                        Retirer
                      </button>
                    </div>
                  )}
                  <input
                    type="text"
                    className="form-control search-form-control"
                    placeholder="Adresse de Livraison"
                    value={
                      cart && cart.refundedOrder
                        ? cart.refundedOrder.client_id.address
                        : retrievedOrder?.client_id?.address
                        ? retrievedOrder?.client_id?.address
                        : cart.client_id && cart.client_id.address
                        ? cart.client_id.address
                        : address
                    }
                    onChange={(e) => setAddress(e.target.value)}
                  />

                  <textarea
                    className="form-control search-form-control"
                    placeholder="Notes ou Demandes Spéciales"
                    rows={3}
                    value={
                      cart && cart.refundedOrder
                        ? cart.refundedOrder.client_id.note
                        : retrievedOrder?.client_id?.note
                        ? retrievedOrder?.client_id?.note
                        : cart.client_id && cart.client_id.note
                        ? cart.client_id.note
                        : note
                    }
                    onChange={(e) => setNote(e.target.value)}
                    style={{ width: "100%" }}
                  />
                  {retrievedOrder &&
                  retrievedOrder?.status === "En livraison" ? (
                    <>
                      <button
                        className={"btn btn-success mb-2" + btnClass}
                        style={{
                          width: "100%",
                          background: "#009688",
                          height: "50px",
                        }}
                        disabled={!retrievedOrder && cart.items?.length === 0}
                        type="button"
                        onClick={() => refund("retour")}
                      >
                        {t("Retour")}
                      </button>{" "}
                      <button
                        className={"btn btn-success mb-2" + btnClass}
                        style={{
                          width: "100%",
                          background: "#009688",
                          height: "50px",
                        }}
                        disabled={!retrievedOrder && cart.items?.length === 0}
                        type="button"
                        onClick={() => refund("echange")}
                      >
                        {t("Echange")}
                      </button>
                    </>
                  ) : null}

                  {cart.operationType !== "Echange" &&
                  ((retrievedOrder && retrievedOrder?.status === "Payée") ||
                    retrievedOrder?.status === "Retour") ? null : (
                    <button
                      className={"btn btn-success mb-2" + btnClass}
                      style={{
                        width: "100%",
                        background: "#009688",
                        height: "50px",
                      }}
                      disabled={
                        (!retrievedOrder && cart.items?.length === 0) ||
                        cart.items.some(
                          (item: any) =>
                            item.outOFStock === true && !retrievedOrder,
                        )
                      }
                      type="submit"
                    >
                      {(retrievedOrder &&
                        retrievedOrder?.status === "En cours") ||
                      retrievedOrder?.status === "Nouvelle"
                        ? t("Livraison")
                        : retrievedOrder &&
                          retrievedOrder.status === "En livraison"
                        ? t("Payer")
                        : t("confirm")}
                    </button>
                  )}
                  {!retrievedOrder && (
                    <button
                      className={"btn btn-success mb-2" + btnClass}
                      style={{
                        width: "100%",
                        background: "#009688",
                        height: "50px",
                      }}
                      disabled={
                        !cart.items.some(
                          (item: any) => item.outOFStock === true,
                        )
                      }
                    >
                      {t("Pre-confirmer")}
                    </button>
                  )}

                  <div className="payment-switch">
                    <div className="row">
                      <div className="col-2">
                        <label className="s-outline  s-outline-success  mb-4 mr-2">
                          {t("Payée")}
                        </label>
                      </div>
                      <div className="col-2">
                        {" "}
                        <label className="switch s-icons s-outline s-outline-success mb-4 mr-2">
                          <input
                            type="checkbox"
                            defaultChecked={isPaid}
                            onChange={(e) => setIsPaid(e.currentTarget.checked)}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                    {(retrievedOrder?.status === "En cours" ||
                      retrievedOrder?.status === "Nouvelle") && (
                      <div className="row">
                        <div className="col-2">
                          <label className="s-outline  s-outline-success  mb-4 mr-2">
                            {t("Livraison gratuite")}
                          </label>
                        </div>
                        <div className="col-2">
                          {" "}
                          <label className="switch s-icons s-outline s-outline-success mb-4 mr-2">
                            <input
                              type="checkbox"
                              checked={freeDelivery}
                              onChange={(e) =>
                                setFreeDelivery(e.currentTarget.checked)
                              }
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </form>
              )}
            </div>
            <hr></hr>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlineOrderConfirmation;
